export default "__VITE_ASSET__I6x5avVZ__"